import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ThumbDown = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.27419 13.9855C6.78568 14.2495 7.41116 14.1321 7.7921 13.7006L10.8383 10.25H13C13.6904 10.25 14.25 9.69036 14.25 9V3C14.25 2.30964 13.6904 1.75 13 1.75H4.87588C4.39674 1.75 3.95977 2.02388 3.7509 2.45509L1.92503 6.22463C1.80984 6.46244 1.75 6.72326 1.75 6.9875V9.09677C1.75 9.78713 2.30964 10.3468 3 10.3468H6.05949L5.61706 12.6303C5.51098 13.1778 5.77859 13.7297 6.27419 13.9855ZM9.75 9.21631L7.25992 12.0369L7.70506 9.73943C7.74765 9.51962 7.6898 9.29227 7.54732 9.11954C7.40485 8.94681 7.19266 8.84677 6.96875 8.84677H3.25V6.9875C3.25 6.94975 3.25855 6.91249 3.275 6.87852L5.03257 3.25H9.75V9.21631ZM11.25 8.75H12.75V3.25H11.25V8.75Z"
      fill="currentColor"
    />
  </Icon>
));

export default ThumbDown;
